<template>
  <div>
    <el-table
      :border="true"
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column v-if="hasPermissionToAuditLogs" :label="fields.id.label"  :prop="fields.id.name" sortable="custom">
        <template slot-scope="scope">{{ presenter(scope.row, 'id') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.name.label"
        :prop="fields.name.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'name') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.lastName.label"
        :prop="fields.lastName.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'lastName') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.picture.label"
        :prop="fields.picture.name"
        align="center"
      >
        <template slot-scope="scope">
          <app-list-item-image :value="presenter(scope.row, 'picture')"></app-list-item-image>
        </template>
      </el-table-column>

      <el-table-column
        :label="fields.uid.label"
        :prop="fields.uid.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'uid') }}</template>
      </el-table-column>

      <el-table-column :label="fields.teams.label" :prop="fields.teams.name">
        <template slot-scope="scope">
          <app-list-item-relation-to-many
            :label="fields.teams.label"
            :permission="fields.teams.readPermission"
            :url="fields.teams.viewUrl"
            :value="presenter(scope.row, 'teams')"
          ></app-list-item-relation-to-many>
        </template>
      </el-table-column>

      <el-table-column
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column>

      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/fan/${scope.row.id}`">
              <el-button type="text">
                <app-i18n code="common.view"></app-i18n>
              </el-button>
            </router-link>

            <router-link :to="`/fan/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button type="text">
                <app-i18n code="common.edit"></app-i18n>
              </el-button>
            </router-link>

            <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              type="text"
              v-if="hasPermissionToDestroy"
            >
              <app-i18n code="common.destroy"></app-i18n>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { FanModel } from '@modules/fan/fan-model';
import { mapGetters, mapActions } from 'vuex';
import { FanPermissions } from '@modules/fan/fan-permissions';
import { i18n } from '@shared/i18n';

const { fields } = FanModel;

export default {
  name: 'app-fan-list-table',

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'fan/list/rows',
      count: 'fan/list/count',
      loading: 'fan/list/loading',
      pagination: 'fan/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'fan/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new FanPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new FanPermissions(this.currentUser).destroy;
    },

    fields() {
      return fields;
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'fan/list/doChangeSort',
      doChangePaginationCurrentPage:
        'fan/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'fan/list/doChangePaginationPageSize',
      doMountTable: 'fan/list/doMountTable',
      doDestroy: 'fan/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return FanModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
</style>
